// extracted by mini-css-extract-plugin
module.exports = {"screenshareHolder":"Screenshare_screenshareHolder__1OphV","previewHolder":"Screenshare_previewHolder__1mHxh"};